import Image from "next/image";
import Slider from "react-slick";

import { partners } from "../../consts/cconsts";

export const Partners = () => {
  const settings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 5,
  };

  return (
    <Slider {...settings}>
      {partners.map((item) => (
        <div className="inline-block align-middle" key={item.name}>
          <Image
            alt={item.name}
            className="-mt-3 px-12 pb-6 sm:mt-0"
            height={181}
            priority={true}
            src={`/img/partners/${item.name}.png`}
            width={251}
          />
        </div>
      ))}
    </Slider>
  );
};
